import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { resetPasswordSchema } from "../../schema";
import { resetpassapi } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { useSelector } from "react-redux";

const initialValues = {
  newpassword: "",
  confirmpassword: "",
};

export const ResetPassword = () => {
  const { profileData } = useSelector((state) => state.profileReducer);
  const navigate = useNavigate();
  const toast = useRef(null);

  const handleresetpass = async (values, action) => {
    resetpassapi(values, profileData?.token)
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: `${response?.data?.message}`,
        });
        setTimeout(async () => {
          action.resetForm();
          navigate("/");
        }, 1000);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const { values, errors, handleChange, handleSubmit, touched, handleBlur } =
    useFormik({
      initialValues,
      validationSchema: resetPasswordSchema,
      onSubmit: (values, action) => handleresetpass(values, action),
    });

  return (
    <>
      <Toast ref={toast} />
      <div className="loop-text-cls-add">
        <h1>The Loop</h1>
      </div>
      <div className="all-login-signup-forgot-pass-model">
        <div class="auth_screen">
          <div class="row">
            <div class="col-lg-12">
              <div class="auth_box">
                <div class="auth_body mt-4 w-100">
                  <h6 class="mb-4">Reset Password</h6>
                  <form onSubmit={handleSubmit} class="">
                    <div class="form-content">
                      <div class="form-group">
                        <label class="form-label all-label-same">
                          New Password
                        </label>
                        <input
                          type="password"
                          name="newpassword"
                          formcontrolname="newpassword"
                          maxlength="50"
                          class="form-control input-underline input-lg"
                          placeholder="Enter New Password"
                          value={values.newpassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.newpassword && touched.newpassword ? (
                          <p className="form-error">{errors.newpassword}</p>
                        ) : null}
                      </div>
                      <div class="form-group mb-2 mt-4">
                        <div class="d-flex justify-content-between">
                          <label class="form-label all-label-same">
                            Confirm Password
                          </label>
                        </div>
                        <input
                          type="password"
                          name="confirmpassword"
                          formcontrolname="confirmpassword"
                          maxlength="30"
                          class="form-control input-underline input-lg "
                          placeholder="Enter Confirm Password"
                          value={values.confirmpassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.confirmpassword && touched.confirmpassword ? (
                          <p className="form-error">{errors.confirmpassword}</p>
                        ) : null}
                      </div>
                      <div class="mt-2 text-end">
                        <div class="row mt-4 mb-2">
                          <div class="col-lg-12">
                            <button
                              type="submit"
                              // onClick={handleresetpass}
                              class="btn fill_btn same-all-btn-primary"
                              onChange={handleChange}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
